import { ref, watch } from 'vue'
import type { Ref } from 'vue'
export function useCustomerTableFilter(tableData: Ref<Array<any>>, searchArr: Array<any>) {
  // const allData = ref(JSON.parse(JSON.stringify(tableData)));
  const allData = tableData.value;

  const filtered = ref(tableData.value)
  const search = ref(searchArr)
  //this is failing on customer field, as some of them are null
  watch(
    () => search.value,
    (newVal, oldVal) => {
      //console.log("watch called on searchArr.value = " + JSON.stringify(newVal));
      //let lowercase = newVal.map(text=>{
      //  return text.toString().toLowerCase();
      //});
      filtered.value = allData.filter((row) => {
        //console.log("..row = " + JSON.stringify(row));
        const customer_id = newVal['id'].toString().toLowerCase()
        const name = newVal['customer'].toString().toLowerCase()
        //const company = newVal['companyName'].toString().toLowerCase()
        //const searchEmail = newVal['email'].toString().toLowerCase();
        //const searchInvoiceName = newVal['invoiceName'].toString().toLowerCase()
        const searchJobCount = newVal['project count'].toString().toLowerCase()
        const searchInvCount = newVal['invoice count'].toString().toLowerCase()
        const projCountRow = row['project count'];  //number
        const archived = newVal['archived'].toString().toLowerCase()
        const notes = newVal['notes'].toString().toLowerCase()
        //const notes = newVal['notes'].toString().toLowerCase();
        //const rowCust = row.customer;
        //const custField = custObj.name + ' ' + custObj.companyName;
        //const owner = newVal['owner'].toString().toLowerCase();
        //email can be null
        //const invoiceNameRow = row['invoiceName']
        //const emailRow = row['email'];
        return (
          row['id'].toString().toLowerCase().includes(customer_id) &&
          row['customer'].toString().toLowerCase().includes(name) &&
         // row['companyName'].toString().toLowerCase().includes(company) &&
         /* (invoiceNameRow != null
            ? invoiceNameRow.toString().toLowerCase().includes(searchInvoiceName)
            : true) &&*/
          //(emailRow!=null ? emailRow.toString().toLowerCase().includes(searchEmail) : true);// &&
          //row['project count'].toString().toLowerCase().includes(searchJobCount)
          ( projCountRow != null ? projCountRow.toString().toLowerCase().includes(searchJobCount) : true) &&
          row['archived'].toString().toLowerCase().includes(archived) &&
          row['notes'].toString().toLowerCase().includes(notes)
        )
        //(row['owner'] ? row['owner'].toString().toLowerCase().includes(owner) : false); // &&
        // row['customerName'].toString().toLowerCase().includes(customer) &&
        //rowCust ? rowCust.name.toString().toLowerCase().includes(customer) : false;
        //row.customer.name.toString().toLowerCase().includes(customer) &&
      })
      //filtered.value = props.tableData.filter(row => row[props.columnName].toString().toLowerCase().includes(newVal.toLowerCase()));
     // tableData.value = filtered.value;
    },
    { deep: true }
  )

  return { filtered }
}
